<template>
  <div>
    <div class="box no-padding">
      <div class="header">Service Rate Settings</div>
      <div class="body">
        <table v-if="!isMobile">
          <thead>
            <th></th>
            <th>Fuel Surcharge<br/>Per Mile</th>
            <th>{{ travelInsuranceLabel }}<br/>Per Mile</th>
            <th v-show="showAirportFee">Airport Fee</th>
            <th>Per Mile Rate</th>
            <th>Base Rate</th>
            <th>Mileage <br/>Threshold</th>
            <th>Flat 2nd Pax Fee</th>
            <th>Flat Add. Pax Fee</th>
            <th colspan="2" class="discount">Discount</th>
            <th colspan="2" class="roundtrip" v-if="type !== 'asap'">Roundtrip</th>
          </thead>
          <tbody>
            <tr v-for="(service, index) in services" v-if="showService(service)">
              <td :title="service.id">{{ service.name }}</td>
              <td>
                <vue-autonumeric :options="dollar10" :disabled="saving" v-model="service[type].gasFee" ></vue-autonumeric>
              </td>
              <td>
                <!-- v-on:autoNumeric:rawValueModified.native="updateValue(index, 'travelInsurance')" -->
                <vue-autonumeric :options="dollar" :disabled="saving"
                  v-model="service[type].travelInsurance" 
                  ></vue-autonumeric>
                  <div v-show="false">{{ service[type] }}</div>
              </td>
              <td v-show="showAirportFee">
                <!-- v-on:autoNumeric:rawValueModified.native="updateValue(index, 'airportFee')" -->
                <vue-autonumeric :options="dollar" :disabled="saving"
                  v-model="service[type].airportFee" 
                  ></vue-autonumeric>
              </td>
              <td>
                <!-- v-on:autoNumeric:rawValueModified.native="updateValue(index, 'mileageRate')" -->
                <vue-autonumeric :options="dollar" :disabled="saving"
                  v-model="service[type].mileageRate"
                  ></vue-autonumeric>
              </td>
              <td>
                <!-- v-on:autoNumeric:rawValueModified.native="updateValue(index, 'fare')" -->
                <vue-autonumeric :options="dollar2" :disabled="saving"
                  v-model="service[type].fare" class="base-rate"
                  ></vue-autonumeric>
              </td>
              <td>
                <!-- v-on:autoNumeric:rawValueModified.native="updateValue(index, 'mileageThreshold')" -->
                <vue-autonumeric :options="'floatPos'" :disabled="saving"
                  v-model="service[type].mileageThreshold" class="mile-threshold"
                  ></vue-autonumeric>
              </td>
              <td>
                <!-- v-on:autoNumeric:rawValueModified.native="updateValue(index, 'flat2paxFee')" -->
                <vue-autonumeric :options="dollar" :disabled="saving"
                  v-model="service[type].flat2paxFee"
                  ></vue-autonumeric>
              </td>
              <td>
                <!-- v-on:autoNumeric:rawValueModified.native="updateValue(index, 'flatNpaxFee')" -->
                <vue-autonumeric :options="dollar" :disabled="saving"
                  v-model="service[type].flatNpaxFee"
                  ></vue-autonumeric>
              </td>
              <td class="discount p-R-0">
                <select v-model="service[type].discountType" :disabled="saving"
                  @change="updateValue(index, 'discountType')">
                  <option value="$">$</option>
                  <option value="%">%</option>
                </select>
              </td>
              <td class="discount p-L-0 discount-value">
                <!-- v-on:autoNumeric:rawValueModified.native="updateValue(index, 'discountAmount')" -->
                <vue-autonumeric :options="oneHundred" :disabled="saving"
                  v-model="service[type].discountAmount" 
                  ></vue-autonumeric>
              </td>
              <td class="roundtrip p-R-0" v-if="type !== 'asap'">
                <select v-model="service[type].roundtripType" :disabled="saving"
                  @change="updateValue(index, 'roundtripType')">
                  <option value="$">$</option>
                  <option value="%">%</option>
                </select>
              </td>
              <td class="roundtrip p-L-0 discount-value" v-if="type !== 'asap'">
                <!-- v-on:autoNumeric:rawValueModified.native="updateValue(index, 'roundtripAmount')" -->
                <vue-autonumeric :options="oneHundred" :disabled="saving"
                  v-model="service[type].roundtripAmount"
                  ></vue-autonumeric>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="cards" v-else>
          <div class="card" v-for="(service, index) in services" v-if="showService(service)" :key="index">
            <div class="card-header">{{ service.name }}</div>

            <div class="row-fields">
              <div class="title">
                <div class="label">{{ travelInsuranceLabel }} Per Mile</div>
                <vue-autonumeric :options="dollar" :disabled="saving"
                  v-model="service[type].travelInsurance" 
                ></vue-autonumeric>
              </div>

              <div class="title" v-show="showAirportFee">
                <div class="label">Airport Fee</div>
                <vue-autonumeric :options="dollar" :disabled="saving"
                  v-model="service[type].airportFee" 
                ></vue-autonumeric>
              </div>
            </div>

            <div class="row-fields">
              <div class="title">
                <div class="label">Per Mile Rate</div>
                <vue-autonumeric :options="dollar" :disabled="saving"
                  v-model="service[type].mileageRate"
                ></vue-autonumeric>
              </div>

              <div class="title">
                <div class="label">Base Rate</div>
                <vue-autonumeric :options="dollar2" :disabled="saving"
                  v-model="service[type].fare" 
                ></vue-autonumeric>
              </div>

              <div class="title">
                <div class="label">Mileage Threshold</div>
                <vue-autonumeric :options="'floatPos'" :disabled="saving"
                  v-model="service[type].mileageThreshold" 
                ></vue-autonumeric>
              </div>
            </div>

            <div class="row-fields">
              <div class="title">
                <div class="label">Flat 2nd Pax Fee</div>
                <vue-autonumeric :options="dollar" :disabled="saving"
                  v-model="service[type].flat2paxFee"
                ></vue-autonumeric>
              </div>

              <div class="title">
                <div class="label">Flat Add. Pax Fee</div>
                <vue-autonumeric :options="dollar" :disabled="saving"
                  v-model="service[type].flatNpaxFee"
                ></vue-autonumeric>
              </div>
            </div>

            <div class="row-fields">
              <div class="title">
                <div class="label">Discount</div>
                <div class="discount">
                  <select v-model="service[type].discountType" :disabled="saving"
                    @change="updateValue(index, 'discountType')">
                    <option value="$">$</option>
                    <option value="%">%</option>
                  </select>
                  <vue-autonumeric :options="oneHundred" :disabled="saving"
                    v-model="service[type].discountAmount" 
                  ></vue-autonumeric>
                </div>
              </div>
              <div class="title" v-if="type !== 'asap'">
                <div class="label">Roundtrip</div>
                <div class="discount">
                  <select v-model="service[type].roundtripType" :disabled="saving"
                    @change="updateValue(index, 'roundtripType')">
                    <option value="$">$</option>
                    <option value="%">%</option>
                  </select>
                  <vue-autonumeric :options="oneHundred" :disabled="saving"
                    v-model="service[type].roundtripAmount"
                  ></vue-autonumeric>
                </div>
              </div>
            </div>

          </div>
        </div>

        <div class="discount-date">
          <div class="row">
            <div class="column medium-6 date-box">
              <div class="label">Discount Date</div>
              <div class="field">
                <label class="sub-label">Start</label>
                <date-picker v-model="discountStart" input-class="servicearea-date-input"
                  lang="en" class="date-input-block" :disabled="saving"
                  :not-before="minDate"></date-picker>
              </div>
              <div class="field">
                <label class="sub-label">End</label>
                <date-picker v-model="discountEnd" input-class="servicearea-date-input"
                  lang="en" class="date-input-block" :disabled="saving"
                  :not-before="discountEndMin"></date-picker>
              </div>
            </div>
            <div class="column medium-6 dc-type-box">
              <span class="dc-type" @click="dcTypeAdmin = !dcTypeAdmin">
                <i class="fas fa-check-square fa-2x" v-if="dcTypeAdmin"></i>
                <i :class="['far fa-square fa-2x', {'disabled':selectedServiceArea === 0}]" v-else></i>
                Backoffice
              </span>
              <span class="dc-type" @click="dcTypeWidget = !dcTypeWidget">
                <i class="fas fa-check-square fa-2x" v-if="dcTypeWidget"></i>
                <i :class="['far fa-square fa-2x', {'disabled':selectedServiceArea === 0}]" v-else></i>
                Widget
              </span>
              <span class="dc-type" @click="dcTypeApp = !dcTypeApp">
                <i class="fas fa-check-square fa-2x" v-if="dcTypeApp"></i>
                <i :class="['far fa-square fa-2x', {'disabled':selectedServiceArea === 0}]" v-else></i>
                CA
              </span>
              <span class="dc-type" @click="dcTypeCsr = !dcTypeCsr">
                <i class="fas fa-check-square fa-2x" v-if="dcTypeCsr"></i>
                <i :class="['far fa-square fa-2x', {'disabled':selectedServiceArea === 0}]" v-else></i>
                CSR
              </span>
            </div>
          </div>
        </div>

      </div>
    </div>

    <div class="d-flex g20">
      <div class="box no-padding d2d" v-if="type !== 'asap' && isD2D">
        <div class="header">Service Rate Settings (Ground Bookings on Flights)</div>
        <div class="body">
          <table v-if="!isMobile">
            <thead>
              <th></th>
              <th colspan="2" class="discount">Discount</th>
              <th colspan="2" class="roundtrip" >Roundtrip</th>
            </thead>
            <tbody>
              <tr v-for="(service, index) in services" v-if="showService(service)">
                <td>{{ service.name }}</td>
                <td class="discount p-R-0">
                  <select v-model="service.flight.onewayType" :disabled="saving"
                    @change="updateValue(index, 'discountType')">
                    <option value="$">$</option>
                    <option value="%">%</option>
                  </select>
                </td>
                <td class="discount p-L-0 discount-value">
                  <vue-autonumeric :options="oneHundred" :disabled="saving"
                    v-model="service.flight.onewayRate" 
                    ></vue-autonumeric>
                </td>
                <td class="roundtrip p-R-0">
                  <select v-model="service.flight.roundtripType" :disabled="saving"
                    @change="updateValue(index, 'roundtripType')">
                    <option value="$">$</option>
                    <option value="%">%</option>
                  </select>
                </td>
                <td class="roundtrip p-L-0 discount-value">
                  <vue-autonumeric :options="oneHundred" :disabled="saving"
                    v-model="service.flight.roundtripRate"
                    ></vue-autonumeric>
                </td>
              </tr>
            </tbody>
          </table>
  
          <div class="cards" v-else>
            <div class="card" v-for="(service, index) in services" v-if="showService(service)" :key="index">
              <div class="card-header">{{ service.name }}</div>
  
              <div class="row-fields">
                <div class="title">
                  <div class="label">Discount</div>
                  <div class="discount">
                    <select v-model="service[type].discountType" :disabled="saving"
                      @change="updateValue(index, 'discountType')">
                      <option value="$">$</option>
                      <option value="%">%</option>
                    </select>
                    <vue-autonumeric :options="oneHundred" :disabled="saving"
                      v-model="service[type].discountAmount" 
                    ></vue-autonumeric>
                  </div>
                </div>
                <div class="title" v-if="type !== 'asap'">
                  <div class="label">Roundtrip</div>
                  <div class="discount">
                    <select v-model="service[type].roundtripType" :disabled="saving"
                      @change="updateValue(index, 'roundtripType')">
                      <option value="$">$</option>
                      <option value="%">%</option>
                    </select>
                    <vue-autonumeric :options="oneHundred" :disabled="saving"
                      v-model="service[type].roundtripAmount"
                    ></vue-autonumeric>
                  </div>
                </div>
              </div>
  
            </div>
          </div>
  
        </div>
      </div>

      <div class="box no-padding conv-box">
        <div class="header">Convenience Fee</div>
        <div class="body">
          <table v-if="!isMobile">
            <thead>
              <th></th>
              <th>Type</th>
              <th>Value</th>
            </thead>
            <tbody>
              <tr v-for="(service, index) in services" v-if="showService(service)">
                <td>{{ service.name }}</td>
                <td>
                  <select v-model="service[type].portalFeeType" :disabled="saving" @change="updateValue(index, 'portalType')">
                    <option value="$">$</option>
                    <option value="%">%</option>
                  </select>
                </td>
                <td>
                  <vue-autonumeric :options="'floatPos'" :disabled="saving" v-model="service[type].portalFee" ></vue-autonumeric>
                </td>
              </tr>
            </tbody>
          </table>
  
          <div class="cards" v-else>
            <div class="card" v-for="(service, index) in services" v-if="showService(service)" :key="index">

              <div class="card-header">{{ service.name }}</div>
              <div class="row-fields">
                <div class="title">
                  <div class="label">Type</div>
                  <div class="discount">
                    <select v-model="service[type].portalFeeType" :disabled="saving" @change="updateValue(index, 'portalType')">
                      <option value="$">$</option>
                      <option value="%">%</option>
                    </select>
                  </div>
                </div>
                <div class="title" v-if="type !== 'asap'">
                  <div class="label">Value</div>
                  <div class="discount">
                    <vue-autonumeric :options="'floatPos'" :disabled="saving" v-model="service[type].portalFee" ></vue-autonumeric>
                  </div>
                </div>
              </div>
  
            </div>
          </div>
  
        </div>
      </div>
    </div>

    <div class="box no-padding">
      <div class="header">Provider Rate Settings</div>
      <div class="body">
        <table v-if="!isMobile">
          <thead>
            <th></th>
            <th>Per Mile Rate</th>
            <th>Base Fee</th>
            <th>Bonus Per Mile Party</th>
            <th>Flat 2nd Pax Fee</th>
            <th>Flat Add. Pax Fee</th>
            <th>Discount Rate</th>
          </thead>
          <tbody>
            <tr v-for="service in services" v-if="showService(service)" :key="service.id">
              <td>{{ service.name }}</td>
              <td>
                <vue-autonumeric v-model="service[type].provMileage"
                  :options="dollar" :disabled="saving"></vue-autonumeric>
              </td>
              <td>
                <vue-autonumeric v-model="service[type].provBaseFee"
                  :options="dollar2" :disabled="saving"></vue-autonumeric>
              </td>
              <td>
                <span v-if="!service.isShared">--</span>
                <vue-autonumeric v-else v-model="service[type].provBonus"
                  :options="dollar" :disabled="saving"></vue-autonumeric>
              </td>
              <td>
                <vue-autonumeric v-model="service[type].prov2paxFee"
                  :options="dollar" :disabled="saving"></vue-autonumeric>
              </td>
              <td>
                <vue-autonumeric v-model="service[type].provNpaxFee"
                  :options="dollar" :disabled="saving"></vue-autonumeric>
              </td>
              <td>
                <vue-autonumeric v-model="service[type].provDiscountRate"
                  :options="percent" :disabled="saving"></vue-autonumeric>
              </td>
            </tr>
          </tbody>
        </table>

        <div class="cards" v-else>
          <div class="card" v-for="service in services" v-if="showService(service)" :key="service.id">
            <div class="card-header">
              {{ service.name }}
            </div>
            <div class="row-fields">
              <div class="title">
                <div class="label">Per Mile Rate</div>
                <vue-autonumeric v-model="service[type].provMileage"
                  :options="dollar" :disabled="saving"></vue-autonumeric>
              </div>

              <div class="title">
                <div class="label">
                  Base Fee
                </div>
                <vue-autonumeric v-model="service[type].provBaseFee"
                  :options="dollar" :disabled="saving"></vue-autonumeric>
              </div>
            </div>

            <div class="row-fields">
              <div class="title">
                <div class="label">Flat 2nd Pax Fee</div>
                <vue-autonumeric v-model="service[type].prov2paxFee"
                    :options="dollar" :disabled="saving"></vue-autonumeric>
              </div>

              <div class="title">
                <div class="label">Flat Add. Pax Fee</div>
                <vue-autonumeric v-model="service[type].provNpaxFee"
                  :options="dollar" :disabled="saving"></vue-autonumeric>
              </div>
            </div>

            <div class="row-fields">
              <div class="title">
                <div class="label">Discount Rate</div>
                <vue-autonumeric v-model="service[type].provDiscountRate"
                  :options="percent" :disabled="saving"></vue-autonumeric>
              </div>
              <div class="title">
                <div class="label">Bonus Per Mile Party</div>
                <span v-if="!service.isShared">--</span>
                <vue-autonumeric v-else v-model="service[type].provBonus"
                  :options="dollar" :disabled="saving"></vue-autonumeric>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="column medium-6" v-if="type !== 'asap' && selectedServiceArea === 0">
        <div class="box no-padding">
          <div class="header">Pickup Types</div>
          <div class="body">
            <span class="error-msg" v-if="error.pickupTypes">{{ error.pickupTypes }}</span>
            <table>
              <thead>
                <th></th>
                <th>Curbside</th>
                <th>Meet &amp; Greet</th>
                <th>Fee</th>
                <th></th>
              </thead>
              <tbody>
                <tr v-for="(service, index) in pickupTypesGlobal" :key="service.id">
                  <td>{{ service.name }}</td>
                  <td>
                    <span @click="toggleGlobalPickupType(index, 'Curbside')">
                      <i class="fas fa-check-square fa-2x" v-if="service.pickupTypes.Curbside && service.pickupTypes.Curbside.enabled"></i>
                      <i class="far fa-square fa-2x" v-else></i>
                    </span>
                  </td>
                  <td>
                    <span @click="toggleGlobalPickupType(index, 'MeetAndGreet')">
                      <i class="fas fa-check-square fa-2x" v-if="service.pickupTypes.MeetAndGreet && service.pickupTypes.MeetAndGreet.enabled"></i>
                      <i class="far fa-square fa-2x" v-else></i>
                    </span>
                  </td>
                  <td>
                    <vue-autonumeric :options="dollar" v-model="service.pickupTypes.MeetAndGreet.fee" :disabled="saving"
                      v-on:autoNumeric:rawValueModified.native="toggleGlobalPickupTypeFee(index, 'MeetAndGreet')"></vue-autonumeric>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="column medium-6" v-if="type !== 'asap' && selectedServiceArea !== 0">
        <div class="box no-padding">
          <div class="header">Pickup Types</div>
          <div class="body">
            <span class="error-msg" v-if="error.pickupTypes">{{ error.pickupTypes }}</span>
            <table>
              <thead>
                <th></th>
                <th>Curbside</th>
                <th>Meet &amp; Greet</th>
                <th>Fee</th>
                <th></th>
              </thead>
              <tbody>
                <tr v-for="(service, index) in services" :key="service.id" v-if="showService(service)">
                  <td>{{ service.name }}</td>
                  <td>
                    <span @click="togglePickupType(index, 'Curbside', 'enabled')">
                      <i class="fas fa-check-square fa-2x" v-if="service.pickupTypes.Curbside && service.pickupTypes.Curbside.enabled"></i>
                      <i :class="{'far fa-square fa-2x':true, 'disabled':selectedServiceArea === 0}" v-else></i>
                    </span>
                  </td>
                  <td>
                    <span @click="togglePickupType(index, 'MeetAndGreet', 'enabled')">
                      <i class="fas fa-check-square fa-2x" v-if="service.pickupTypes.MeetAndGreet && service.pickupTypes.MeetAndGreet.enabled"></i>
                      <i :class="{'far fa-square fa-2x':true, 'disabled':selectedServiceArea === 0}" v-else></i>
                    </span>
                  </td>
                  <td>
                    <vue-autonumeric :options="dollar" v-model="service.pickupTypes.MeetAndGreet.fee" :disabled="saving"
                      v-on:autoNumeric:rawValueModified.native="togglePickupType(index, 'MeetAndGreet', 'fee')"></vue-autonumeric>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div :class="{'column medium-4 end':true, 'p-L-10': type !== 'asap'}">
        <div class="box no-padding">
          <div class="header">Holiday Rates</div>
          <div class="body">
            <table class="holiday-rates">
              <tbody>
                <tr v-for="(service, index) in services" :key="service.id" v-if="showService(service)">
                  <td>{{ service.name }}</td>
                  <td>
                    <select v-model="service[type].holidayRateType" :disabled="saving"
                      @change="updateValue(index, 'holidayRateType')">
                      <option value="$">$</option>
                      <option value="%">%</option>
                    </select>
                  </td>
                  <td>
                    <vue-autonumeric :options="oneHundred" v-model="service[type].holidayRateAmount" :disabled="saving"
                      v-on:autoNumeric:rawValueModified.native="updateValue(index, 'holidayRateAmount')"></vue-autonumeric>
                  </td>
                </tr>
              </tbody>
            </table>

            <div class="discount-date holiday">
              <div class="row">
                <div class="column medium-12 date-box">
                  <div class="label">Holiday Date</div>
                  <div class="field">
                    <date-picker v-model="holidayDate" input-class="servicearea-date-input"
                      lang="en" class="date-input-block" :disabled="saving"
                      :not-before="minDate"></date-picker>
                    <date-picker v-model="holidayDate2" input-class="servicearea-date-input"
                      lang="en" class="date-input-block" :disabled="saving"
                      :not-before="minDate" v-show="holidays[1]"
                      @clear="clearDate(1)"></date-picker>
                    <date-picker v-model="holidayDate3" input-class="servicearea-date-input"
                      lang="en" class="date-input-block" :disabled="saving"
                      :not-before="minDate" v-show="holidays[2]"
                      @clear="clearDate(2)"></date-picker>
                    <date-picker v-model="holidayDate4" input-class="servicearea-date-input"
                      lang="en" class="date-input-block" :disabled="saving"
                      :not-before="minDate" v-show="holidays[3]"
                      @clear="clearDate(3)"></date-picker>
                    <date-picker v-model="holidayDate5" input-class="servicearea-date-input"
                      lang="en" class="date-input-block" :disabled="saving"
                      :not-before="minDate" v-show="holidays[4]"
                      @clear="clearDate(4)"></date-picker>
                    <date-picker v-model="holidayDate6" input-class="servicearea-date-input"
                      lang="en" class="date-input-block" :disabled="saving"
                      :not-before="minDate" v-show="holidays[5]"
                      @clear="clearDate(5)"></date-picker>
                    <date-picker v-model="holidayDate7" input-class="servicearea-date-input"
                      lang="en" class="date-input-block" :disabled="saving"
                      :not-before="minDate" v-show="holidays[6]"
                      @clear="clearDate(6)"></date-picker>
                    <date-picker v-model="holidayDate8" input-class="servicearea-date-input"
                      lang="en" class="date-input-block" :disabled="saving"
                      :not-before="minDate" v-show="holidays[7]"
                      @clear="clearDate(7)"></date-picker>
                    <date-picker v-model="holidayDate9" input-class="servicearea-date-input"
                      lang="en" class="date-input-block" :disabled="saving"
                      :not-before="minDate" v-show="holidays[8]"
                      @clear="clearDate(8)"></date-picker>
                    <date-picker v-model="holidayDate10" input-class="servicearea-date-input"
                      lang="en" class="date-input-block" :disabled="saving"
                      :not-before="minDate" v-show="holidays[9]"
                      @clear="clearDate(9)"></date-picker>
                    <div class="button xsmall block" v-if="holidays.filter(x => x).length <= 10" @click="addHoliday"><i class="fas fa-plus fa-fw"></i>Add Holiday</div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>

    <div class="box no-padding" v-if="selectedServiceArea > 0 && type !== 'asap'">
      <div class="header">Promotional Pricing</div>
      <div class="body">
        <table class="table" v-if="!isMobile">
          <thead v-show="!promos.loading && promos.list.length > 0">
            <th>Service Type</th>
            <th>Promo Type</th>
            <th>Flat Rate</th>
            <th>Base Rate</th>
            <th>Mileage Threshold</th>
            <th>2nd Pax Fee</th>
            <th>Add. Pax Fee</th>
            <th></th>
          </thead>
          <tbody>
          <tr v-show="promos.loading">
            <td colspan="8">
              <div class="promo-loading">
                <i class="fa fa-spinner fa-spin"></i>
                <span>LOADING PROMOS</span>
              </div>
            </td>
          </tr>
          <tr v-for="(promo, index) in promos.list">
            <td class="table-label">{{ promo.serviceName }}</td>
            <td class="table-label">
              <span v-if="promo.type === 'flat'">Flat Rate</span>
              <span v-else>Discount Mileage Rate</span>
            </td>
            <td class="table-label">
              <span v-if="promo.type === 'flat'">${{ promo.flatRate.toFixed(2) }}</span>
              <span v-else>--</span>
            </td>
            <td class="table-label">
              <span v-if="promo.type === 'discount'">${{ promo.discountBaseRate.toFixed(2) }}</span>
              <span v-else>--</span>
            </td>
            <td class="table-label">
              <span v-if="promo.type === 'discount'">${{ promo.discountMileageRate.toFixed(2) }}</span>
              <span v-else>--</span>
            </td>
            <td class="table-label">
              <span v-if="promo.type === 'flat'">${{ promo.flat2ndPAXFee.toFixed(2) }}</span>
              <span v-else>${{ promo.discount2ndPAXFee.toFixed(2) }}</span>
            </td>
            <td class="table-label">
              <span v-if="promo.type === 'flat'">${{ promo.flatAddPAXFee.toFixed(2) }}</span>
              <span v-else>${{ promo.discountAddPAXFee.toFixed(2) }}</span>
            </td>
            <td class="table-label"><a class="button cta xsmall error" href="javascript:;" @click="removePromo(index)">REMOVE</a></td>
          </tr>

          </tbody>
        </table>
        <div class="cards" v-else>
          <div class="card promo-card"  v-for="(promo, index) in promos.list" :key="index">
            <div class="title">
              <div class="label">Service Type</div>
              <div class="value">{{ promo.serviceName }}</div>
            </div>
            <div class="title">
              <div class="label">Promo Type</div>
              <div class="value" v-if="promo.type === 'flat'">Flat Rate</div>
              <div class="value" v-else>Discount Mileage Rate</div>
            </div>
            <div class="title">
              <div class="label">Flat Rate</div>
              <div class="value" v-if="promo.type === 'flat'">${{ promo.flatRate.toFixed(2) }}</div>
              <div class="value" v-else>--</div>
            </div>
            <div class="title">
              <div class="label">Base Rate</div>
              <div class="value" v-if="promo.type === 'flat'">${{ promo.discountBaseRate.toFixed(2) }}</div>
              <div class="value" v-else>Discount</div>
            </div>
            <div class="title">
              <div class="label">Mileage Threshold</div>
              <div class="value" v-if="promo.type === 'flat'">${{ promo.discountMileageRate.toFixed(2) }}</div>
              <div class="value" v-else>--</div>
            </div>
            <div class="title">
              <div class="label">2nd Pax Fee</div>
              <div class="value" v-if="promo.type === 'flat'">${{ promo.flat2ndPAXFee.toFixed(2) }}</div>
              <div class="value" v-else>${{ promo.discount2ndPAXFee.toFixed(2) }}</div>
            </div>
            <div class="title">
              <div class="label">Add. Pax Fee</div>
              <div class="value" v-if="promo.type === 'flat'">${{ promo.flatAddPAXFee.toFixed(2) }}</div>
              <div class="value" v-else>${{ promo.discountAddPAXFee.toFixed(2) }}</div>
            </div>
            <div class="action">
              <a class="button cta xsmall error" href="javascript:;" @click="removePromo(index)">REMOVE</a>
            </div>
          </div>
        </div>
        <div class="discount-date promo" v-show="!promos.loading">
          <div class="row">
            <div class="column medium-6 medium-offset-3">
              <div class="button cta xsmall success" @click="showPromoForm">
                ADD ANOTHER SERVICE
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <promo></promo>
  </div>
</template>

<script>
/* global CONFIG */
import moment from 'moment'
import VueAutonumeric from 'vue-autonumeric'
import DatePicker from 'vue2-datepicker'
import Promo from './Promo'
import ApiServices from '@/modules/api/pricing/service-types'

export default {
  name: 'pricing-settings',
  components: { VueAutonumeric, DatePicker, Promo },
  props: ['type', 'isMobile'],
  data () {
    return {
      showAirportFee: false,
      dollar: {
        currencySymbol: '$ ',
        currencySymbolPlacement: 'p',
        minimumValue: '0',
        maximumValue: '200.00'
      },
      dollar2: {
        currencySymbol: '$ ',
        currencySymbolPlacement: 'p',
        minimumValue: '0',
        maximumValue: '10000.00'
      },
      dollar10: {
        currencySymbol: '$ ',
        currencySymbolPlacement: 'p',
        minimumValue: '0',
        maximumValue: '9.99'
      },
      percent: {
        currencySymbol: ' %',
        currencySymbolPlacement: 's',
        minimumValue: '0',
        maximumValue: '100'
      },
      passenger: {
        minimumValue: '0',
        maximumValue: '9',
        decimalPlaces: 0
      },
      oneHundred: {
        minimumValue: '0',
        maximumValue: '100'
      },
      luggage: {
        minimumValue: '0',
        maximumValue: '18',
        decimalPlaces: 0
      },
      error: {
        pickupTypes: ''
      },
      promos: {
        loading: false,
        list: []
      },
      holidays: [
        true, false, false, false, false,
        false, false, false, false, false
      ]
    }
  },
  computed: {
    travelInsuranceLabel () { return this.$settings.get('TravelInsuranceLabel') },
    selectedBrand () { return this.$store.state.pricing.brandId },
    selectedServiceArea () { return this.$store.state.pricing.serviceArea.activeId },
    services () { return this.$store.state.pricing.serviceTypes.list.filter(x => x.brandId === this.selectedBrand && x.brandEnabled && x.enabled && !x.isCharter && !x.isRental) },
    promoRefreshID () { return this.$store.state.pricing.promo.refreshID },
    discountStart: {
      get () {
        let serviceArea = this.$store.state.pricing.serviceArea
        let discountStart = this.type === 'asap' ? serviceArea.asapDiscountStart : serviceArea.discountStart
        if (!discountStart) { return null }
        return moment(discountStart, 'YYYY-MM-DD').toDate()
      },
      set (value) {
        if (this.type === 'asap') {
          this.$store.commit('pricing/setAsapDiscountStart', moment(value).format('YYYY-MM-DD'))
        } else {
          this.$store.commit('pricing/setDiscountStart', moment(value).format('YYYY-MM-DD'))
        }
      }
    },
    discountEnd: {
      get () {
        let serviceArea = this.$store.state.pricing.serviceArea
        let discountEnd = this.type === 'asap' ? serviceArea.asapDiscountEnd : serviceArea.discountEnd
        if (!discountEnd) { return null }
        return moment(discountEnd, 'YYYY-MM-DD').toDate()
      },
      set (value) {
        if (this.type === 'asap') {
          this.$store.commit('pricing/setAsapDiscountEnd', moment(value).format('YYYY-MM-DD'))
        } else {
          this.$store.commit('pricing/setDiscountEnd', moment(value).format('YYYY-MM-DD'))
        }
      }
    },
    holidayDate: {
      get () {
        let serviceArea = this.$store.state.pricing.serviceArea
        let holidayDate = this.type === 'asap' ? serviceArea.asapHolidayDate : serviceArea.holidayDate
        if (!holidayDate) { return null }
        return moment(holidayDate, 'YYYY-MM-DD').toDate()
      },
      set (value) {
        if (this.type === 'asap') {
          this.$store.commit('pricing/setAsapHolidayDate', moment(value).format('YYYY-MM-DD'))
        } else {
          this.$store.commit('pricing/setHolidayDate', moment(value).format('YYYY-MM-DD'))
        }
      }
    },
    holidayDate2: {
      get () {
        let serviceArea = this.$store.state.pricing.serviceArea
        let holidayDate = this.type === 'asap' ? serviceArea.asapHolidayDate2 : serviceArea.holidayDate2
        if (!holidayDate) { return null }
        return moment(holidayDate, 'YYYY-MM-DD').toDate()
      },
      set (value) {
        this.$store.commit('pricing/setHolidayData', {
          index: 2,
          type: this.type,
          value: value ? moment(value).format('YYYY-MM-DD') : null
        })
      }
    },
    holidayDate3: {
      get () {
        let serviceArea = this.$store.state.pricing.serviceArea
        let holidayDate = this.type === 'asap' ? serviceArea.asapHolidayDate3 : serviceArea.holidayDate3
        if (!holidayDate) { return null }
        return moment(holidayDate, 'YYYY-MM-DD').toDate()
      },
      set (value) {
        this.$store.commit('pricing/setHolidayData', {
          index: 3,
          type: this.type,
          value: value ? moment(value).format('YYYY-MM-DD') : null
        })
      }
    },
    holidayDate4: {
      get () {
        let serviceArea = this.$store.state.pricing.serviceArea
        let holidayDate = this.type === 'asap' ? serviceArea.asapHolidayDate4 : serviceArea.holidayDate4
        if (!holidayDate) { return null }
        return moment(holidayDate, 'YYYY-MM-DD').toDate()
      },
      set (value) {
        this.$store.commit('pricing/setHolidayData', {
          index: 4,
          type: this.type,
          value: value ? moment(value).format('YYYY-MM-DD') : null
        })
      }
    },
    holidayDate5: {
      get () {
        let serviceArea = this.$store.state.pricing.serviceArea
        let holidayDate = this.type === 'asap' ? serviceArea.asapHolidayDate5 : serviceArea.holidayDate5
        if (!holidayDate) { return null }
        return moment(holidayDate, 'YYYY-MM-DD').toDate()
      },
      set (value) {
        this.$store.commit('pricing/setHolidayData', {
          index: 5,
          type: this.type,
          value: value ? moment(value).format('YYYY-MM-DD') : null
        })
      }
    },
    holidayDate6: {
      get () {
        let serviceArea = this.$store.state.pricing.serviceArea
        let holidayDate = this.type === 'asap' ? serviceArea.asapHolidayDate6 : serviceArea.holidayDate6
        if (!holidayDate) { return null }
        return moment(holidayDate, 'YYYY-MM-DD').toDate()
      },
      set (value) {
        this.$store.commit('pricing/setHolidayData', {
          index: 6,
          type: this.type,
          value: value ? moment(value).format('YYYY-MM-DD') : null
        })
      }
    },
    holidayDate7: {
      get () {
        let serviceArea = this.$store.state.pricing.serviceArea
        let holidayDate = this.type === 'asap' ? serviceArea.asapHolidayDate7 : serviceArea.holidayDate7
        if (!holidayDate) { return null }
        return moment(holidayDate, 'YYYY-MM-DD').toDate()
      },
      set (value) {
        this.$store.commit('pricing/setHolidayData', {
          index: 7,
          type: this.type,
          value: value ? moment(value).format('YYYY-MM-DD') : null
        })
      }
    },
    holidayDate8: {
      get () {
        let serviceArea = this.$store.state.pricing.serviceArea
        let holidayDate = this.type === 'asap' ? serviceArea.asapHolidayDate8 : serviceArea.holidayDate8
        if (!holidayDate) { return null }
        return moment(holidayDate, 'YYYY-MM-DD').toDate()
      },
      set (value) {
        this.$store.commit('pricing/setHolidayData', {
          index: 8,
          type: this.type,
          value: value ? moment(value).format('YYYY-MM-DD') : null
        })
      }
    },
    holidayDate9: {
      get () {
        let serviceArea = this.$store.state.pricing.serviceArea
        let holidayDate = this.type === 'asap' ? serviceArea.asapHolidayDate9 : serviceArea.holidayDate9
        if (!holidayDate) { return null }
        return moment(holidayDate, 'YYYY-MM-DD').toDate()
      },
      set (value) {
        this.$store.commit('pricing/setHolidayData', {
          index: 9,
          type: this.type,
          value: value ? moment(value).format('YYYY-MM-DD') : null
        })
      }
    },
    holidayDate10: {
      get () {
        let serviceArea = this.$store.state.pricing.serviceArea
        let holidayDate = this.type === 'asap' ? serviceArea.asapHolidayDate10 : serviceArea.holidayDate10
        if (!holidayDate) { return null }
        return moment(holidayDate, 'YYYY-MM-DD').toDate()
      },
      set (value) {
        this.$store.commit('pricing/setHolidayData', {
          index: 10,
          type: this.type,
          value: value ? moment(value).format('YYYY-MM-DD') : null
        })
      }
    },
    minDate () { return moment().toDate() },
    discountEndMin () {
      let date = new Date()
      if (this.discountStart) {
        date = this.discountStart
      }
      return date
    },
    saving () { return this.$store.state.pricing.saving },
    dcTypeWidget: {
      get () {
        let serviceArea = this.$store.state.pricing.serviceArea
        let type = this.type === 'asap' ? serviceArea.asapDiscountWidget : serviceArea.discountWidget
        return type
      },
      set (value) {
        this.$store.commit('pricing/setDcType', {
          field: this.type === 'asap' ? 'asapDiscountWidget' : 'discountWidget',
          value: value
        })
      }
    },
    dcTypeAdmin: {
      get () {
        let serviceArea = this.$store.state.pricing.serviceArea
        let type = this.type === 'asap' ? serviceArea.asapDiscountAdmin : serviceArea.discountAdmin
        return type
      },
      set (value) {
        this.$store.commit('pricing/setDcType', {
          field: this.type === 'asap' ? 'asapDiscountAdmin' : 'discountAdmin',
          value: value
        })
      }
    },
    dcTypeApp: {
      get () {
        let serviceArea = this.$store.state.pricing.serviceArea
        let type = this.type === 'asap' ? serviceArea.asapDiscountApp : serviceArea.discountApp
        return type
      },
      set (value) {
        this.$store.commit('pricing/setDcType', {
          field: this.type === 'asap' ? 'asapDiscountApp' : 'discountApp',
          value: value
        })
      }
    },
    dcTypeCsr: {
      get () {
        let serviceArea = this.$store.state.pricing.serviceArea
        let type = this.type === 'asap' ? serviceArea.asapDiscountCSR : serviceArea.discountCSR
        return type
      },
      set (value) {
        this.$store.commit('pricing/setDcType', {
          field: this.type === 'asap' ? 'asapDiscountCSR' : 'discountCSR',
          value: value
        })
      }
    },
    pickupTypesGlobal () { return this.$store.state.pricing.global.pickupTypes },
    isD2D () {
      let conf = CONFIG.brands.find(x => x.id === this.$store.state.pricing.brandId)
      if (conf) return conf.code === 'd2d'
      return false
    }
  },
  methods: {
    showService (data) {
      return (this.selectedServiceArea === 0 && data.brandEnabled) || 
        (data.enabled && data.brandEnabled)
    },
    updateValue (index, field) {
      this.$store.commit('pricing/updateServiceTypeField', {
        id: this.services[index].id,
        field: field,
        type: this.type,
        value: this.services[index][this.type][field]
      })
    },
    togglePickupType (index, type, field) {
      let self = this
      if (self.saving || (this.selectedServiceArea === 0 && field === 'enabled')) { return }

      let pickupType = self.services[index].pickupTypes[type]
      if (!pickupType) {
        self.$store.commit('pricing/updateServiceTypePickupType', {
          id: this.services[index].id,
          type: type,
          field: 'name',
          value: type
        })
      }
      let value = pickupType[field]
      if (field === 'enabled') {
        value = !value
      }
      self.$store.commit('pricing/updateServiceTypePickupType', {
        id: this.services[index].id,
        type: type,
        field: field,
        value: value
      })
      self.$nextTick().then(() => {
        self.$forceUpdate()
      })
    },
    toggleAirportFee () {
      let self = this
      if (!self.selectedServiceArea) {
        self.showAirportFee = true
        return
      }
      self.showAirportFee = false
      self.$sdk.get('/geofences/' + self.selectedServiceArea + '/airport', {
        token: self.$store.state.session.sessionToken
      }, r => {
        if (r.error) {
          return
        }
        if (r.airports.length > 0) {
          self.showAirportFee = true
        }
      })
    },
    loadPromos () {
      let self = this
      self.promos.loading = true
      self.promos.list = []
      self.$sdk.get('/geofences/' + self.selectedServiceArea + '/promos', {
        token: self.$store.state.session.sessionToken
      }, r => {
        self.promos.loading = false
        if (r.error) {
          return
        }
        self.promos.list = r.list
      })
    },
    removePromo (index) {
      let self = this
      let promo = self.promos.list[index]
      let promos = []
      for (let i = 0; i < self.promos.list.length; i++) {
        if (i === index) {
          continue
        }
        promos.push(self.promos.list[i])
      }
      self.promos.list = promos
      self.$sdk.delete('/geofences/' + self.selectedServiceArea + '/promos/' + promo.id, {
        token: self.$store.state.session.sessionToken
      }, r => {
        console.log('PROMO REMOVED', r)
      })
    },
    showPromoForm () {
      this.$store.commit('pricing/setGeofencePromoShow', true)
      this.$store.commit('pricing/setGeofencePromoList', this.promos.list)
    },
    save () {
      let self = this

      self.error.pickupTypes = ''
      if (self.type !== 'asap') {
        self.services.forEach(service => {
          let unchecked = true
          for (let index in service.pickupTypes) {
            if (service.pickupTypes[index].enabled) {
              unchecked = false
            }
          }
          if (unchecked) {
            self.error.pickupTypes = 'Must select atleast one pickup type per service.'
          }
        })
      }

      if (this.saving || !!self.error.pickupTypes) { return }

      self.$store.commit('pricing/setSaving', true)
      ApiServices.setPriceSettings(self, this.type, res => {
        self.$store.commit('pricing/setSaving', false)
        let response = {
          show: true,
          status: 'success',
          message: 'Successfully updated pricing data!',
          extra: ''
        }
        if (res.error) {
          response.status = 'error'
          response.message = 'Oops! Something went wrong...'
          response.extra = res.error.message
        }
        self.$emit('response', response)

        let origData = []
        res.list.forEach(service => {
          origData.push({
            id: service.serviceType.id,
            enabled: self.cleanCopy(service.enabled),
            asap: self.cleanCopy(service.asap),
            charter: self.cleanCopy(service.charter),
            flight: self.cleanCopy(service.flight),
            future: self.cleanCopy(service.future),
            pickupTypes: self.cleanCopy(service.pickupTypes),
            rental: self.cleanCopy(service.rental)
          })
        })
        self.$store.commit('pricing/setOriginalData', origData)
      })
    },
    cleanCopy (x) {
      return JSON.parse(JSON.stringify(x))
    },
    addHoliday () {
      let index = this.holidays.lastIndexOf(true)
      this.holidays[index + 1] = true
      this.$forceUpdate()
    },
    clearDate (index) {
      let tempVal = []
      let lastIndex = this.holidays.lastIndexOf(true)

      if (lastIndex == index) {
        this.holidays[index] = false
        this.$forceUpdate()
        return
      }

      for (let x = index; x < 10; x++) {
        if (this[`holidayDate${x+1}`]) {
          tempVal.push({
            index: x,
            val: this[`holidayDate${x+1}`]
          })
        }
      }
      tempVal.forEach(temp => {
        this[`holidayDate${temp.index}`] = temp.val
        this[`holidayDate${temp.index + 1}`] = null
        this.holidays[temp.index - 1] = true
        this.holidays[temp.index] = false
      })
    },
    toggleGlobalPickupType (i, type) {
      let tmp = this.pickupTypesGlobal[i].pickupTypes[type].enabled
      if (tmp === false || tmp === true) tmp = !tmp
      if (tmp === '') tmp = true
      this.$store.commit('pricing/updateGlobalPickupTypeData', {
        index: i,
        type: type,
        field: 'enabled',
        value: tmp
      })
    },
    toggleGlobalPickupTypeFee (i, type) {
      // console.log(i, type) // DO nothing
    }
  },
  watch: {
    promoRefreshID (value) {
      if (value !== this.selectedServiceArea) { return }
      this.loadPromos()
    }
  },
  mounted () {
    this.$store.commit('pricing/setDiscountStart', '')
    this.$store.commit('pricing/setDiscountEnd', '')
    this.$store.commit('pricing/setHolidayDate', '')
    this.$store.commit('pricing/setAsapDiscountStart', '')
    this.$store.commit('pricing/setAsapDiscountEnd', '')
    this.$store.commit('pricing/setAsapHolidayDate', '')

    if (this.$store.state.pricing.serviceArea.activeId !== 0) {
      if (this.services && this.services[0] && this.services[0].discountStart) {
        this.$store.commit('pricing/setDiscountStart', this.services[0].discountStart)
      }
      if (this.services && this.services[0] && this.services[0].discountEnd) {
        this.$store.commit('pricing/setDiscountEnd', this.services[0].discountEnd)
      }
      if (this.services && this.services[0] && this.services[0].holidayDate) {
        this.$store.commit('pricing/setHolidayDate', this.services[0].holidayDate)
      }
  
      if (this.services && this.services[0] && this.services[0].asapDiscountStart) {
        this.$store.commit('pricing/setAsapDiscountStart', this.services[0].asapDiscountStart)
      }
      if (this.services && this.services[0] && this.services[0].asapDiscountEnd) {
        this.$store.commit('pricing/setAsapDiscountEnd', this.services[0].asapDiscountEnd)
      }
      if (this.services && this.services[0] && this.services[0].asapHolidayDate) {
        this.$store.commit('pricing/setAsapHolidayDate', this.services[0].asapHolidayDate)
      }

      if (this.services && this.services[0]) {
        this.$store.commit('pricing/setDcType', {
          field: 'discountWidget',
          value: this.services[0].discountWidget
        })
        this.$store.commit('pricing/setDcType', {
          field: 'discountAdmin',
          value: this.services[0].discountAdmin
        })
        this.$store.commit('pricing/setDcType', {
          field: 'discountApp',
          value: this.services[0].discountApp
        })
        this.$store.commit('pricing/setDcType', {
          field: 'discountCSR',
          value: this.services[0].discountCSR
        })
        this.$store.commit('pricing/setDcType', {
          field: 'asapDiscountWidget',
          value: this.services[0].asapDiscountWidget
        })
        this.$store.commit('pricing/setDcType', {
          field: 'asapDiscountAdmin',
          value: this.services[0].asapDiscountAdmin
        })
        this.$store.commit('pricing/setDcType', {
          field: 'asapDiscountApp',
          value: this.services[0].asapDiscountApp
        })
        this.$store.commit('pricing/setDcType', {
          field: 'asapDiscountCSR',
          value: this.services[0].asapDiscountCSR
        })
      }
    } else {
      this.$store.commit('pricing/setDcType', {field: 'discountWidget', value: true})
      this.$store.commit('pricing/setDcType', {field: 'discountAdmin', value: true})
      this.$store.commit('pricing/setDcType', {field: 'discountApp', value: true})
      this.$store.commit('pricing/setDcType', {field: 'discountCSR', value: true})
      this.$store.commit('pricing/setDcType', {field: 'asapDiscountWidget', value: true})
      this.$store.commit('pricing/setDcType', {field: 'asapDiscountAdmin', value: true})
      this.$store.commit('pricing/setDcType', {field: 'asapDiscountApp', value: true})
      this.$store.commit('pricing/setDcType', {field: 'asapDiscountCSR', value: true})
    }

    this.holidays = [
      true, false, false, false, false,
      false, false, false, false, false
    ]
    if (this.selectedServiceArea !== 0) {
      for (let i = 1; i < 10; i++) {
        this.$store.commit('pricing/setHolidayData', {
          type: 'asap',
          index: i + 1,
          value: this.services[0][`asapHolidayDate${i+1}`]
        })
        this.$store.commit('pricing/setHolidayData', {
          type: 'future',
          index: i + 1,
          value: this.services[0][`holidayDate${i+1}`]
        })
        this.holidays[i] = false
        if ((this.type === 'asap' && this.services[0][`asapHolidayDate${i+1}`]) ||
          (this.type === 'future' && this.services[0][`holidayDate${i+1}`])
        ) {
          this.holidays[i] = true
        }
      }
    }

    this.loadPromos()
    this.toggleAirportFee()
  }
}
</script>

<style lang="scss" scoped>
.p-R-0 { padding-right: 0; }
.p-L-0 { padding-left: 0; }
.p-L-10 { padding-left: 10px; }
.row{ max-width: 100%; }

.box{
  background: #fff;
  border-radius: 2px;
  border: 1px solid #b0c6e4;
  margin-bottom: 30px;
  box-shadow: 0 2px 3px rgba(0, 0, 20, 0.1);

  .header{
    padding: 10px;
    background: #0D79F2;
    text-transform: uppercase;
    color: #fff;
    font-weight: 600;
    font-size: 14px;
  }
  .body{
    .error-msg{
      font-size: 12px;
      color: #fff;
      font-style: italic;
      display: block;
      padding: 5px;
      text-align: center;
      background: #ff4d4d;
    }
  }
  &.d2d{
    max-width: 500px;
  }
}

.g20{
  gap: 20px;
}

table{
  background: #fff;
  width: 100%;
  // border: 1px solid rgba(0, 0, 0, 0.15);
  // box-shadow: 0 2px 5px rgba(0, 0, 0, 0.1);
  // border-radius: 3px;
  text-align: left;
  border-spacing: 0;
  text-align: center;

  thead th{
    font-size: 13px;
    font-weight: 100;
    color: #777;
    padding: 10px 0 0;
  }
  tbody{
    td{
      vertical-align: baseline;
      padding: 8px 7px;
      font-size: 14px;

      &:last-child{ padding-bottom: 15px; }
    }
    input{
      max-width: 90px;
      margin: 0;
      font-size: 13px;
      display: inline-block;
      text-align: center;
    }
    .small-input { width: 60px; }
    .discount, .roundtrip{
      max-width: 90px;
      min-width: 50px;
    }
    .fa-square, .fa-check-square{ color: #0D79F2; }
    i.disabled {
      opacity: .4;
      cursor: not-allowed;
    }
    .base-rate{
      max-width: 80px;
    }
    .mile-threshold{
      width: 70px;
    }
  }
  .discount{ background: #fafafa; }
  .roundtrip{ background: #f5f5f5; }
}
.date-box{
  align-items: center;
  display: flex;
  justify-content: center
}
.discount-date{
  background: #eaf2fb;
  text-align: left;
  border-top: 1px solid #b0c6e4;
  padding: 10px 0;

  &.holiday, &.promo{ text-align: center; }
  .label, .field{ display: inline-block; }
  .label{
    font-size: 14px;
    font-weight: 600;
    color: #3b5573;
    margin-right: 10px;
  }
  &.holiday{
    .label{
      vertical-align: top;
      line-height: 30px;
    }
  }
  .field{
    min-width: 150px;
    padding-right: 10px;
  }
  .sub-label{
    display: block;
    font-size: 11px;
    color: #888;
    line-height: 1;
    margin: 0 0 3px 2px;
  }
  .table-label{
    text-align: right;
    padding-right: 20px!important;
  }
  .date-input-block{
    display: block;
    width: 100%;
    margin-bottom: 2px;
  }
  .button{ margin-top: 10px; }
}
.dc-type-box{
  height: 48px;
  align-items: center;
  display: flex;
  justify-content: center
}
.dc-type{
  display: inline-block;
  margin: 0 10px;
  font-size: 16px;
  cursor: pointer;

  i{
    vertical-align: -2px;
    color: #0D79F2;
    font-size: 21px;
    margin-right: 3px;
  }
}
.holiday-rates, .conv-box{
  select{
    max-width: 60px;
    min-width: 60px;
  }
}

select{
  border: 1px solid #ddd;
  padding: 8px 15px 8px 8px;
  color: #333;
  height: 42px;
  position: relative;
  font-size:14px;
  outline: none;
  text-align: center;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: url('/assets/img/dropdown-arrow.png');
  background-repeat: no-repeat;
  background-position: calc(100% + 4px) 50%;
  transition: all .35s ease;

  &.has-error{ border-color: #f20d0d; }
  &:disabled{ background-color: #eee; }
}

@media only screen and (max-width: 430px) {
  .p-L-10 {
    padding: 0;
  }
  .discount-date .field {
    width: 100%;
  }

  .date-box {
    padding: 0 10px;
  }

  .cards {
    padding-top: 10px;
    .card {
      border: 1px solid #b0c6e4;
      margin: 0 10px;
      margin-bottom: 15px;
      padding-bottom: 3px;
      border-bottom: 5px solid #b0c6e4;
      font-weight: 700;

      > div {
        margin-bottom: 3px;
      }

      &.promo-card {
        display: flex;
        flex-wrap: wrap;
        padding-bottom: 0;
        .action {
          display: flex;
          width: 100%;
          justify-content: center;
          margin: 0;
          margin-top: 5px;
          border-top: 1px solid #b0c6e4;
          padding: 10px;
          background-color: #eaf2fb;
        }
      }

      .row-fields {
        display: flex;
      }

      .card-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background-color: #eaf2fb;
        padding: 5px 10px;
        font-size: 14px;
        .name {
          font-weight: 900;
        }
        .amount {
          margin-left: 5px;
          font-size: 14px;
        }
        .status {
          text-transform: uppercase;
          font-size: 12px;
          font-weight: 900;
        }
      }

      .title {
        display: flex;
        flex-direction: column;
        padding: 5px 10px;

        input {
          margin: 0;
          padding: 5px 10px;
          font-size: 14px;
        }

        select {
          margin: 0;
          padding: 5px 10px;
          font-size: 14px;
          height: 35px;
          width: 80px;
        }

        .discount {
          display: flex;
          width: 100%;
        }
      }

      .label {
        font-size: 11px;
        color: #666;
        font-weight: 100;
      }

      .value {
        margin-right: 10px;
        font-size: 13px;
        font-weight: 900;
      }

    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Pricing/PricingSettings.vue